/**
 * Home Page - Full landing page with all sections
 */
import React from 'react';
import SEO from '../components/ui/SEO';
import { getOrganizationSchema, getLocalBusinessSchema } from '../utils/schema';
import Hero from '../components/sections/Hero';
import WomenEmpowered from '../components/sections/WomenEmpowered';
import AboutPreview from '../components/sections/AboutPreview';
import ServicesOverview from '../components/sections/ServicesOverview';
import GreenEnergyPreview from '../components/sections/GreenEnergyPreview';
import WhyChooseUs from '../components/sections/WhyChooseUs';
import KeyLocations from '../components/sections/KeyLocations';
import HissenPartnership from '../components/sections/HissenPartnership';
import ContactCTA from '../components/sections/ContactCTA';

const Home = () => (
  <main>
    <SEO 
      title="ISAAC Logistic Solutions India Pvt. Ltd. | Shipping & Logistics Company in Thoothukudi"
      description="ISAAC Logistic Solutions is a premier women-led shipping agency and logistics company in Thoothukudi, Tamil Nadu. Delivering vessel husbanding, project cargo, freight forwarding, customs clearance, and green port energy solutions."
      canonicalUrl="https://www.isaacgroup.net/"
      schema={[getOrganizationSchema(), getLocalBusinessSchema()]}
    />
    <Hero />
    <WomenEmpowered />
    <AboutPreview />
    <ServicesOverview />
    <GreenEnergyPreview />
    <WhyChooseUs />
    <KeyLocations />
    <HissenPartnership />
    <ContactCTA />
  </main>
);

export default Home;
